import { withParams, ref } from 'vuelidate/lib/validators/common';

export var onlyEmail = function onlyEmail(otherProp) {
  return withParams({ type: otherProp }, function (value) {
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
    );
  });
};

export var noSpecialChars = function noSpecialChars(otherProp) {
  return withParams({ type: otherProp }, function (value) {
    return (/^[^À-ÿ\u00f1\u00d1]*$/.test(value)
    );
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/validators/only-email.js
// module id = ./src/validators/only-email.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16